import { render, staticRenderFns } from "./ApplicantInformationEndorsement.vue?vue&type=template&id=61234fc2&scoped=true"
import script from "./ApplicantInformationEndorsement.vue?vue&type=script&lang=js"
export * from "./ApplicantInformationEndorsement.vue?vue&type=script&lang=js"
import style0 from "./ApplicantInformationEndorsement.vue?vue&type=style&index=0&id=61234fc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61234fc2",
  null
  
)

export default component.exports